module.exports = __webpack_public_path__ + "img/Protecting-Harvests-Rubber-Tapping-650x340.edfe2f5e.png";